module.exports = __webpack_public_path__ + "img/share-transparent.b1fca6eb.gif";